import { render, staticRenderFns } from "./recent-activity.vue?vue&type=template&id=7c068596&scoped=true"
import script from "./recent-activity.vue?vue&type=script&lang=js"
export * from "./recent-activity.vue?vue&type=script&lang=js"
import style0 from "./recent-activity.vue?vue&type=style&index=0&id=7c068596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c068596",
  null
  
)

export default component.exports